import { observer } from 'mobx-react-lite'
import { Avatar, Box } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { useMemo } from 'react'

// @ts-ignore
import quoteArrow from '../../../assets/visuals/quote-arrow.svg'

import styles from './ac-quote.module.scss'
import { AcTypography } from '../ac-typography/ac-typography'
import { ISingleContentBlockQuote } from '@typings'
import { highlightHtmlContent } from '@utilities/helpers/highlight-html-content'

export const AcQuote = observer(
  ({ author, content, title }: ISingleContentBlockQuote) => {
    if (!content) {
      return null
    }

    const [searchParams] = useSearchParams()
    const highlightTerm = searchParams.get('highlight') || ''

    const highlightedContent = useMemo(() => {
      if (!highlightTerm) return content

      return highlightHtmlContent({
        searchTerm: highlightTerm,
        content: content,
      })
    }, [content, highlightTerm])

    return (
      <Box maxWidth={431}>
        <Box
          className={styles['ac-quote']}
          p={2}
          sx={{
            borderRadius: '9px',
            position: 'relative',
          }}>
          <AcTypography
            size="l"
            mb={0}
            html
            weight="bold">
            {highlightedContent}
          </AcTypography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginLeft: '2rem',
          }}>
          <Box
            component="img"
            alt=""
            src={quoteArrow}
          />

          <Box
            sx={{
              display: 'flex',
              alignSelf: 'flex-end',
              alignItems: 'center',
              gap: '0.5rem',
            }}>
            <Avatar
              sx={{
                height: 32,
                width: 32,
              }}
            />
            {author}
          </Box>
        </Box>
      </Box>
    )
  },
)
